import {WebsocketService} from "./websocket.service";
import {Observable} from "rxjs";
import {TableRecordResult} from "../../model/api/table-record-result";
import {getTabId} from "../../utils/browser";
import {TableRequest} from "../../model/api/table-request";

export abstract class TableWsService {

  serviceName: string;

  protected constructor(protected websocketService: WebsocketService, serviceName: string) {
    this.serviceName = serviceName;
  }

  private buildSyncTopic(viewId: string): string {
    // console.log("buildSyncTopic", viewId,
    //   `/queue/${this.serviceName}-updates-${getTabId()}-${viewId}`)
    return `/queue/${this.serviceName}-updates-${getTabId()}-${viewId}`;
  }

  public getSync(viewId: string): Observable<TableRecordResult> {
    //  console.log("getSync", viewId, this.buildSyncTopic(viewId))
    return this.websocketService.subscribeToTopic<any>(this.buildSyncTopic(viewId));
  }
  public unsubscribeSync(viewId: string): void {
    if (viewId && this.websocketService.isConnected()) {
      try {
        this.websocketService.sendMessage(`/app/${this.serviceName}-unsubscribe`, {
          tabId: getTabId(),
          wsViewId: viewId
        });
      } catch (e) {
        console.warn(`Failed to notify server unsubscribe for ${this.serviceName}/${viewId}`, e);
      }
    }

    this.websocketService.unsubscribeFromTopic(this.buildSyncTopic(viewId));
  }

  public getReSync(): Observable<any> {
    //  console.log("getReSync", `/queue/${this.serviceName}-updates`)
    return this.websocketService.subscribeToTopic<any>(`/queue/request-${this.serviceName}-updates`);
  }

  public publishRequest(request: TableRequest, viewId: string, requestId: string) {
   // console.log("publishRequest", request, viewId, requestId)
    const requestToSend: TableRequest = {
      ...request,
      tabId: getTabId(),
      wsViewId: viewId,
      requestId
    } as TableRequest;

    this.websocketService.sendMessage(`/app/${this.serviceName}-refresh`, requestToSend);
  }

  getConnectionStatus() {
    return this.websocketService.getConnectionStatus();
  }

  isConnected(): boolean {
    return this.websocketService.isConnected();
  }
}
